module.exports = "i.icon.fa-user:before {\n  content: \"\\F007\"; }\n\ni.icon.fa-refresh:before {\n  content: \"\\F021\"; }\n\n@media screen and (max-width: 767px) {\n  .padding_on_mobile {\n    padding-bottom: 40px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = ./src/app/login/login.component.scss
// module chunks = main